export default __webpack_public_path__ + "static/media/home.fd021904.jpg";